import { displayNameForCarrier } from "@/Data/displayNameForCarrier";
import * as React from "react";
import {
  IconsLogoBox,
  type IconsLogoAlign,
} from "./CustomComponents/IconsLogoBox";
import { IconsLogoImage } from "./CustomComponents/IconsLogoImage";

type AlignOptions = IconsLogoAlign;

interface CarrierLogoProps {
  carrierIdentifier: string;
  width: number;
  height: number;
  align?: AlignOptions | undefined;
}

const CarrierLogo: React.FC<CarrierLogoProps> = (props: CarrierLogoProps) => {
  const carrierIdentifier = props.carrierIdentifier;

  const displayName = displayNameForCarrier(carrierIdentifier);

  return (
    <IconsLogoBox
      align={props.align || "center"}
      width={props.width}
      height={props.height}
    >
      <IconsLogoImage
        maxHeight={props.height}
        maxWidth={props.width}
        alt={displayName}
        src={`/carrierLogos/${carrierIdentifier}.png`}
      />
    </IconsLogoBox>
  );
};

export default CarrierLogo;
